import script from "./ResponsiveLayout.vue?vue&type=script&lang=ts&setup=true"
export * from "./ResponsiveLayout.vue?vue&type=script&lang=ts&setup=true"

import "./ResponsiveLayout.vue?vue&type=style&index=0&id=47c1f05b&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47c1f05b"]])

export default __exports__